<template>
    <v-data-table :items="leaveEnrollments" :headers="leaveEnrollmentHeaders" :items-per-page="-1">
        <template v-slot:[`item.validFrom`]="{ item }">
            {{ formatDate(item.validFrom, "DD/MM/YYYY")}}
        </template>
        <template v-slot:[`item.validTo`]="{ item }">
            {{ formatDate(item.validTo, "DD/MM/YYYY")}}
        </template>
        <template v-slot:[`item.hasAmount`]="{ item }">
            <span v-if="item.hasAmount"><v-icon color="success">mdi-check</v-icon></span>
        </template>
        <template v-slot:[`item.amount`]="{ item }">
            <span v-if="item.hasAmount">{{item.amount < 0 ? 0 : item.amount }}</span>
            <span v-else>
                <v-icon color="teal darken-4">mdi-infinity</v-icon>
            </span>
        </template>
    </v-data-table>
</template>

<script>
import moment from 'moment/moment';

export default {
    name: 'TabLeave',
    props: {
        leaveEnrollments: Array,
        leaveEnrollmentHeaders: Array
    },
    methods: {
        formatDate(val, format) {
            if (!val) return '';
            return moment(val).format(format);
        }
    }
}
</script>
